import React from "react";
import AlertIcon from "./AlertIcon";
import { css } from "@linaria/core";
import type { AlertType } from "./useQuantityAlerts";

interface P {
  currentMessage: string | null;
  message: string | null;
  alertType?: AlertType;
}

function AlertMessage({ currentMessage, message, alertType = "measures" }: P) {
  return (
    <>
      {currentMessage === null ? null : (
        <div className={currentAlertCss}>
          <AlertIcon alertType={alertType} />
          <div className={`${currentMessageCss}`}>{currentMessage}</div>
        </div>
      )}
      {message === null ? null : <div className={messageCss}>{message}</div>}
    </>
  );
}

const messageCss = css`
  font-weight: 600;
`;

const currentAlertCss = css`
  margin-bottom: 5px;
  display: flex;
`;

const currentMessageCss = css`
  font-weight: 600;
  margin-left: 5px;
`;

export default AlertMessage;
